export class HtmlTextParser {
  static decodeHtmlEntity(str: string): string {
    return str.replace(/&#(\d+);/g, (_: string, dec: number): string => String.fromCharCode(dec));
  }
}
